import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

const getSizeValue = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return '20px';
        case 'medium':
            return '32px';
        case 'large':
            return '64px';
    }
};

const getBorderWidth = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return '2px';
        case 'medium':
            return '3px';
        case 'large':
            return '5px';
    }
};

export const StyledSpinner = styled.div<{ size: 'small' | 'medium' | 'large' }>`
    width: ${props => getSizeValue(props.size)};
    height: ${props => getSizeValue(props.size)};
    border: ${props => getBorderWidth(props.size)} solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;

export const StyledSpinnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-3);
    
    .spinner-message {
        font-size: var(--text-sm);
        color: var(--text-secondary);
        font-weight: var(--font-medium);
    }
`;

export const StyledSpinnerOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--z-modal);
    backdrop-filter: blur(4px);
`;
